import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EmptyListingBlock from '@/app/components/listing/EmptyListingBlock.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NoCurrentlyReadingDocsBlock',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(EmptyListingBlock, {
    title: __props.title,
    useDefaultImage: true,
    class: "empty-reading-now"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        class: "btns btns--font-medium empty-reading-now__btn"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Go to Discover", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["title"]))
}
}

})